module.exports = __webpack_public_path__ + "media/assets/images/flags/mo-1feb407ee7b1a569d34d73d787a22c3a.svg";